import { DashboardOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router';

import Catalog from '@/assets/icons/Catalog';
import { SPOT_CATALOG_PATH } from '@/constants/constants';
import { DataHubEmptyState } from '@/features/DataHub/components/DataHubEmptyState';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { closeDrawer } from '@/slices/drawerSlice';

const ExportDrawerEmptyState = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleNavigate = (path: string) => () => {
    navigate(path);
    dispatch(closeDrawer());
  };

  return (
    <DataHubEmptyState
      actions={[
        {
          label: 'Homepage',
          to: '/markets',
          icon: <DashboardOutlined />,
          onClick: handleNavigate('/markets')
        },
        {
          label: 'Catalog',
          to: `/catalog/${SPOT_CATALOG_PATH}`,
          icon: <Catalog />,
          onClick: handleNavigate(`/catalog/${SPOT_CATALOG_PATH}`)
        }
      ]}
      description='Get started with one of the options below:'
      title='Ready to export data?'
    />
  );
};

export default ExportDrawerEmptyState;
